<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
}
</script>

<style>
  @import "./assets/css/main.css";

  .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px; vector-effect: non-scaling-stroke; shape-rendering: geometricPrecision; overflow: visible;}
</style>
